<div class="" [@pageLoad]="pageLoadState">
  <div
    class="gap-[28px] flex flex-col justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] h-[100%] bg-[#f8fafdff] w-[100%]">
    <div class="gap-[16px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
      <span
        class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-normal font-archivo text-[20px] leading-[32px]">
        {{ dateLabel }}
      </span>
      <span
        class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-bold font-['archivo'] text-[24px] leading-[29px]">
        {{ preferenceTitle }}
      </span>

      <!-- Location recorded for this date from the API -->
      <div
        *ngIf="mealLocationName"
        class="inline-flex items-center gap-[6px] rounded-full bg-[#e8f5e9] px-[16px] py-[8px]">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#2e7d32" />
          <circle cx="12" cy="9" r="2.5" fill="white" />
        </svg>
        <span class="text-[#2e7d32] font-archivo font-semibold text-[18px] leading-[22px]">
          {{ mealLocationName }}
        </span>
      </div>

      <div
        *ngIf="hasAnyWaitlist()"
        class="gap-[8px] flex flex-row shrink-0 justify-center items-center">
        <img src="assets/icons/infoWarning.svg" alt="Information warning" loading="lazy" decoding="async"
          class="w-[32px] h-[32px] shrink-0 justify-start items-start bg-[#ffffffff]" />
        <span
          class="shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[20px] leading-[22px]">
          {{ waitlistBannerText }}
        </span>
      </div>
    </div>

    <section *ngFor="let section of optionSections" class="flex w-full flex-col items-center gap-4">
      <span class="text-[20px] font-semibold leading-[30px] text-[#444955]">
        {{ section.title }}
      </span>
      <div class="flex flex-wrap justify-center gap-[28px]">
        <button type="button" *ngFor="let option of section.options; trackBy: trackByOptionId"
          class="relative h-[120px] w-[160px] shrink-0 overflow-hidden rounded-[16px] border-[3px] p-0 text-center transition duration-200 ease-out hover:-translate-y-[2px] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D]"
          [ngClass]="
              isSelected(section.key, option.id)
                ? (hasWaitlist(option)
                    ? 'border-[#F9A825] shadow-[0_1px_20px_rgba(249,168,37,0.25)]'
                    : 'border-[#43A047] shadow-[0_1px_20px_rgba(67,160,71,0.25)]')
                : 'border-transparent hover:shadow-[0_8px_16px_rgba(15,23,42,0.14)]'
            "
          (click)="selectSectionOption(section.key, option.id)"
          [attr.aria-pressed]="isSelected(section.key, option.id)"
          [attr.aria-label]="option.label">
          <img [src]="option.image" [alt]="option.label" loading="lazy" decoding="async"
            class="absolute inset-0 h-full w-full object-cover" />

          <div *ngIf="isSelected(section.key, option.id)"
            class="absolute right-[8px] top-[8px] z-10 flex h-[24px] w-[24px] items-center justify-center rounded-full"
            [ngClass]="hasWaitlist(option) ? 'bg-[#F9A825]' : 'bg-[#43A047]'"
            aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.5 7.2L5.8 9.5L10.5 4.5" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>

          <div *ngIf="hasWaitlist(option)"
            class="pointer-events-none absolute right-0 bottom-0 z-10 inline-flex items-center gap-1 rounded-tl-[4px] bg-[#f26f24] px-1 py-[2px] text-[16px] font-bold text-white"
            aria-label="Waitlist count">
            <img src="assets/icons/clock.svg" alt="Clock icon" loading="lazy" decoding="async" class="h-4 w-4" />
            <span>{{ option.waitlistCount }}</span>
          </div>
        </button>
      </div>
    </section>

    <div class="flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <NiButton variant="outlined" color="secondary" size="[20px]" [label]="backLabel" leadingIcon="arrowNarrowLeft"
        [px]="'[24px]'" [py]="'[16px]'" [rounded]="'[999px]'" border="1" borderColor="[#5BA5F5]" bg="transparent"
        (onClick)="onBack()" [styleClass]="
            'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
            `'archivo'] text-[18px] leading-[23px]'`"></NiButton>

      <div class="flex w-full flex-col gap-4 lg:w-auto lg:flex-row lg:items-center lg:gap-7">
        <div class="flex flex-col gap-3 text-left text-[#444955] lg:flex-row lg:items-center lg:gap-3 lg:text-right">
          <span class="text-[18px] leading-[25px]">
            {{ preferredHintText }}
          </span>
          <NiButton variant="outlined" color="primary" size="Large" [label]="applyFutureLabel" [px]="'[24px]'"
            [py]="'[16px]'" [rounded]="'[999px]'" border="[2px]" borderColor="[#5BA5F5]" bg="transparent"
            textColor="#2E90FA" (onClick)="onApplyForFuture()" [styleClass]="
                'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
                `'archivo'] text-[18px] leading-[23px]'`"></NiButton>
        </div>
        <NiButton variant="contained" color="primary" size="[20px]" [label]="saveLabel" [px]="'[24px]'" [py]="'[16px]'"
          [rounded]="'[999px]'" bg="[#f26f24ff]" textColor="#ffffff" (onClick)="onSave()" [styleClass]="
              'flex flex-row items-center gap-[10px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
              `'archivo'] text-[18px] leading-[23px]'`"></NiButton>
      </div>
    </div>
  </div>
</div>

<NiAlert *ngIf="toasterMessage" [isVisible]="true" [message]="toasterMessage" [variant]="toasterVariant"
  [position]="'top-right'" [dismissible]="true" [duration]="4000" (onClose)="dismissToaster()">
</NiAlert>
